import jsPDF from "jspdf";
import { detailTrainingGetLogoSis } from "../../../config/apiSPA";
import DateFormat from "../../../components/dateFormater/dateFormat1";

export default class KmkopPdf {
  constructor(data = {}, options = {}) {
    this.date = data.date ?? "-";
    this.assDate = data.assDate ?? "-";
    this.instructor = data.instructor ?? "-";
    this.location = data.location ?? "-";
    this.userName = data.userName ?? "No Name";
    this.participant = data.participant ?? [];
    this.sisLogoUrl = "/generalImage-auth/sisLogo";
    this.maxPage = 1;
    this.minScore = options.minScore ?? 75;
    this.doc = new jsPDF({
      orientation: "l",
      unit: "mm",
      format: "a4",
    });
  }

  async generate() {
    const part = this.calculatingParticipant(this.participant);
    this.maxPage = part.length;
    for (let i = 0; i < this.maxPage; i++) {
      const partPerPage = part[i];
      const page = i + 1;
      await this.generateTemplate(String(page));
      this.generateContent(partPerPage);
      if (page < this.maxPage) {
        this.doc.addPage();
      } else {
        this.doc.save(`REPORT KMKOP ${DateFormat(this.date)} ${this.location}`);
        return true;
      }
    }
  }
  // ------------------------------------------------------------------- Content Devider Logic -------------------------------------------------------
  calculatingParticipant(data) {
    const maxPerPage = 10;
    let pages = [];

    // 1. Bagi menjadi halaman 10 item
    for (let i = 0; i < data.length; i += maxPerPage) {
      pages.push(data.slice(i, i + maxPerPage));
    }

    // 2. Jika ada lebih dari 1 halaman, cek halaman terakhir
    if (pages.length > 1) {
      const lastPage = pages[pages.length - 1];

      // Jika halaman terakhir kurang dari 3 data
      if (lastPage.length < 3) {
        const prevPage = pages[pages.length - 2];

        // Ambil 4 data dari halaman sebelumnya
        const takeCount = 4;

        // Kalau prevPage kurang dari 4, ambil sebanyak yang ada
        const realTake = Math.min(prevPage.length, takeCount);

        const moved = prevPage.splice(prevPage.length - realTake, realTake);

        // Gabungkan data pindahan dengan data terakhir
        pages[pages.length - 1] = [...moved, ...lastPage];
      }
    }

    return pages;
  }
  // ------------------------------------------------------------------- Content ---------------------------------------------------------------------
  async generateContent(part = []) {
    this.mainTextContent();
    this.signTextContent();
    this.tableTextContent(part);
  }
  mainTextContent() {
    this.doc.setFontSize(10);
    this.doc.setFont("Courier", "normal");
    this.doc.text(this.date !== "-" ? DateFormat(this.date) : "-", 57.3, 42);
    this.doc.text(this.assDate !== "-" ? DateFormat(this.assDate) : "-", 57.3, 49);
    this.doc.text(this.location, 57.3, 56);
    this.doc.text(this.instructor, 57.3, 63);
  }
  tableTextContent(data = []) {
    if (data.length < 1) return;
    const maxListY = 10;
    const maxListX = 7; // jumlah nilai
    const startY = 89;
    const startX = 202; // start x nilai
    const gapY = 6;
    const gapX = 10; // Gap nilai
    const x1 = 12; // No.
    const x2 = 17.8; // No. Mp
    const x3 = 49.7; // Name
    const x4 = 101; // Perusahaan
    const x5 = 167; // Posisi
    const x6 = 275.6; // Hasil

    this.doc.setFontSize(7);
    this.doc.setFont("Courier", "normal");
    for (let i = 0; i < maxListY; i++) {
      const part = data[i] ?? false;
      const y = startY + i * gapY;
      if (!part) {
        this.doc.text("-", x1, y, { align: "center" });
        this.doc.text("-----", x2, y);
        this.doc.text("-----", x3, y);
        this.doc.text("-----", x4, y);
        this.doc.text("-----", x5, y, { align: "center" });
        this.doc.text("-----", x6, y, { align: "center" });
        for (let index = 0; index < maxListX; index++) {
          this.doc.text("-", startX + index * gapX, y, { align: "center" });
        }
      } else {
        this.doc.text(String(i + 1), x1, y, { align: "center" });
        this.doc.text(part.minePermitNumb, x2, y);
        this.doc.text(part.nama, x3, y);
        this.doc.text(part.company, x4, y);
        this.doc.text(part.position, x5, y, { align: "center" });
        this.resultFormater(part, x6, y);
        const score = part.score;
        for (let index = 0; index < maxListX; index++) {
          this.scoreFormater(score, index, startX, gapX, y);
        }
      }
    }
  }
  resultFormater(part, x, y) {
    if (part.result === "NYC") {
      this.doc.setTextColor(255, 0, 0);
      this.doc.text(part.result, x, y, { align: "center" });
      this.doc.setTextColor(0, 0, 0);
      return;
    }
    this.doc.text(part.result, x, y, { align: "center" });
    return;
  }
  scoreFormater(score, index, startX, gapX, y) {
    const value = score[index]?.score;
    if (value == null) {
      this.doc.setTextColor(255, 0, 0);
      this.doc.text("-", startX + index * gapX, y, { align: "center" });
      this.doc.setTextColor(0, 0, 0);
      return;
    }
    if (value < this.minScore) {
      this.doc.setTextColor(255, 0, 0);
      this.doc.text(value, startX + index * gapX, y, { align: "center" });
      this.doc.setTextColor(0, 0, 0);
      return;
    }
    this.doc.text(value, startX + index * gapX, y, { align: "center" });
    return;
  }
  signTextContent() {
    this.doc.setFontSize(10);
    this.doc.setFont("Courier", "normal");
    this.doc.text(`Maco, ${this.date !== "-" ? DateFormat(this.date) : "-"}`, 284.4, 153, { align: "right" });
    this.doc.text(this.instructor, 132, 187.6, { align: "center" });
  }
  // ------------------------------------------------------------------- Template ---------------------------------------------------------------------
  async generateTemplate(page = 1) {
    this.titleSecion();
    // ------------------- Table
    this.mainTableSection();
    this.bodyTableSection();
    this.bottomTableSection();
    // ------------------- Static Text
    this.mainTextSection();
    this.tableHeadTextSection();
    this.bottomTextSection();
    // ------------------- Header
    this.headerPageSection();
    // ------------------- Footer
    this.footerPageSection(page);
    // ------------------- Sis Logo
    await this.addLogo();
  }
  //   ----- Static text
  titleSecion() {
    this.doc.setFontSize(12);
    this.doc.setFont("Courier", "bold");
    this.doc.text("REPORT HASIL PELATIHAN", 147, 22, { align: "center" });
    this.doc.text("KELOMPOK MATERI KESELAMATAN OPERASIONAL PLANT (KMKOP)", 147, 31, { align: "center" });
  }
  mainTextSection() {
    this.doc.setFontSize(10);
    this.doc.setFont("Courier", "normal");
    this.doc.text("Tanggal Pelatihan", 10, 42);
    this.doc.text(":", 51, 42);
    this.doc.text("Tanggal Asesmen", 10, 49);
    this.doc.text(":", 51, 49);
    this.doc.text("Lokasi", 10, 56);
    this.doc.text(":", 51, 56);
    this.doc.text("Nama Instruktur", 10, 63);
    this.doc.text(":", 51, 63);
  }
  tableHeadTextSection() {
    this.doc.setFontSize(10);
    this.doc.setFont("Courier", "bold");
    this.doc.text("No", 12.5, 81, { align: "center" });
    this.doc.text("No Mine Permit", 32.4, 81, { align: "center" });
    this.doc.text("Nama Karyawan", 74.4, 81, { align: "center" });
    this.doc.text("Perusahaan", 118.8, 81, { align: "center" });
    this.doc.text("Posisi", 166, 81, { align: "center" });
    this.doc.text("Hasil(*)", 277, 81, { align: "center" });
    // ----------------------------------------------
    this.doc.text("Nilai Pelatihan (Post Test)", 233, 78, { align: "center" });
    // ----------------------------------------------
    this.doc.text("A", 202, 83, { align: "center" });
    this.doc.text("B", 212, 83, { align: "center" });
    this.doc.text("C", 222, 83, { align: "center" });
    this.doc.text("D", 232, 83, { align: "center" });
    this.doc.text("E", 242, 83, { align: "center" });
    this.doc.text("F", 252, 83, { align: "center" });
    this.doc.text("G", 262, 83, { align: "center" });
  }
  bottomTextSection() {
    //----- Keterangan
    this.doc.setFontSize(8);
    this.doc.setFont("Courier", "normal");
    this.doc.text("Ket. Kompetensi Nilai Pelatihan :", 10, 151.7);
    this.doc.text("A  Pengenalan alat dan peralatan workshop dasar", 14.9, 158);
    this.doc.text("B  Hand Injury", 14.9, 162.1);
    this.doc.text("C  Jack & Stand", 14.9, 166);
    this.doc.text("D  Dasar pengelolaan hydro carbon dan B3", 14.9, 170);
    this.doc.text("E  Pengendalian kebisingan", 14.9, 174);
    this.doc.text("F  Manual handling", 14.9, 177.9);
    this.doc.text("G  Keselamatan Isolasi (LOTO)", 14.9, 181.9);
    this.doc.text("Ket. Hasil Nilai Pelatihan (Post Test) :", 10, 187.3);

    this.doc.setFontSize(8);
    this.doc.setFont("Courier", "bold");
    this.doc.text("(*) CO (Competent) - Bila nilai pelatihan >/= 75", 14, 193);
    this.doc.text("(*) NYC (Not Yet Competent) - Bila nilai pelatihan < 75", 14, 197.3);

    // ----- Tanda tangan

    this.doc.setFontSize(10);
    this.doc.setFont("Courier", "normal");
    this.doc.text("Disiapkan Oleh", 132, 164.4, { align: "center" });
    this.doc.text("Direview Oleh", 177, 164.4, { align: "center" });
    this.doc.text("Direview Oleh", 222, 164.4, { align: "center" });
    this.doc.text("Disetujui Oleh", 265, 164.4, { align: "center" });
    this.doc.setFontSize(10);
    this.doc.setFont("Courier", "bold");
    this.doc.text("Instructor Plant", 132, 193.4, { align: "center" });
    this.doc.text("Section Head Plant", 177, 193.4, { align: "center" });
    this.doc.text("Section Head KP", 222, 193.4, { align: "center" });
    this.doc.text("Section Head HRS", 265, 193.4, { align: "center" });
  }
  headerPageSection() {
    this.doc.setFont("courier", "normal");
    this.doc.setFontSize(8);
    this.doc.text(7.8, 12, "Form No.:MACO/HRE/25/F-004");
  }
  footerPageSection(page = 1) {
    this.doc.setFont("courier", "italic");
    this.doc.setFontSize(6);
    this.doc.text(`This document was generated from ppdmaco.com on ${new Date()} by: ${this.userName}`, 7.8, 201);
    this.doc.setFont("courier", "bold");
    this.doc.setFontSize(8);
    this.doc.text(`Halaman ${page} dari ${this.maxPage}`, 287, 201, { align: "right" });
  }
  //   ----- Table and Line
  mainTableSection() {
    // Garis horizontal
    let startY = 37;
    const gapY = 7;
    const totalLine = 5;
    for (let i = 0; i < totalLine; i++) {
      this.doc.line(7.8, startY + i * gapY, 287, startY + i * gapY);
    }
    // Garis vertikal
    this.doc.line(7.8, startY, 7.8, startY + gapY * (totalLine - 1));
    this.doc.line(49, startY, 49, startY + gapY * (totalLine - 1));
    this.doc.line(54.8, startY, 54.8, startY + gapY * (totalLine - 1));
    this.doc.line(287, startY, 287, startY + gapY * (totalLine - 1));
  }
  bodyTableSection() {
    // Header Table
    const startY1 = 74.85;
    const startY2 = 79.7;
    this.doc.line(7.8, startY1, 287, startY1);
    this.doc.line(197, startY2, 267, startY2);
    // Garis horizontal
    const startY = 84.76;
    const gapY = 6;
    const totalLine = 11;
    for (let i = 0; i < totalLine; i++) {
      this.doc.line(7.8, startY + i * gapY, 287, startY + i * gapY);
    }
    // Garis vertikal
    const vert1 = (x = 0) => this.doc.line(x, startY2, x, startY + gapY * (totalLine - 1));
    const vert2 = (x = 0) => this.doc.line(x, startY1, x, startY + gapY * (totalLine - 1));
    vert2(7.8);
    vert2(17);
    vert2(48);
    vert2(100);
    vert2(137.8);
    vert2(197);
    // ----------- verttical line score
    //  gap 10
    vert1(207);
    vert1(217);
    vert1(227);
    vert1(237);
    vert1(247);
    vert1(257);
    // -----------
    vert2(267);
    vert2(287);
  }
  bottomTableSection() {
    // Garis horizontal
    this.doc.line(7.8, 148, 287, 148);
    this.doc.line(7.8, 198.7, 287, 198.7);

    // Garis verikal
    this.doc.line(7.8, 148, 7.8, 198.7);
    this.doc.line(287, 148, 287, 198.7);
  }

  // ----- Image Handler
  async addLogo() {
    try {
      const img = await this.getImage(this.sisLogoUrl);
      this.doc.addImage(img, "jpg", 256, 14, 26, 10);
    } catch (error) {
      this.doc.text("Image Error", 256, 22);
    }
  }
  getImage(url) {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await detailTrainingGetLogoSis(url);
        const base64 = res.img;
        if (!base64) {
          return reject(new Error("Response tidak mengandung field data"));
        }
        // Deteksi apakah sudah lengkap data:image/...
        const imgSrc = base64.startsWith("data:image") ? base64 : `data:image/jpeg;base64,${base64}`;
        const img = new Image();
        // img.crossOrigin = 'anonymous';
        img.onload = () => resolve(img);
        img.onerror = () => reject(new Error("Gagal memuat gambar dari Base64"));
        img.src = imgSrc;
      } catch (error) {
        reject(error);
      }
    });
  }
}
